import { ReactNode, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "@store/store";
import { Outlet, useNavigate, useParams } from "react-router-dom";

import { setDialogConfig, setPopupConfig } from "@store/slices/componentsSlice";
import {
    useLazyGetApplicationResumeQuery,
    useLazyGetApplicationsMarketplaceResumeQuery,
} from "@services/api/applications";
import { setApplicationSelected } from "@store/slices/componentsSlice";

export default function Solicitud() {
    const params = useParams();
    const navigation = useNavigate();
    const dispatch = useDispatch();

    const companiesUser = useSelector((state: RootState) => state.session.companies);
    const applicationSelected = useSelector((state: RootState) => state.components.applicationSelected);
    const sectionSelected = useSelector((state: RootState) => state.components.currentSection.section);

    const [triggerGetApplications] = useLazyGetApplicationResumeQuery();
    const [triggerGetAppsMarketplace] = useLazyGetApplicationsMarketplaceResumeQuery();

    const loadApplicationData = async () => {
        let app_data = undefined;
        let urlParams = new URLSearchParams();
        urlParams.append("q", `company_source:equals:'${params.companyName?.toUpperCase()}'`);
        urlParams.append("q", `id_application_company:equals:'${params.id}'`);

        companiesUser.forEach((company) => urlParams.append("company", company.id));

        let data = undefined;
        if (params.companyName === "pymio") {
            data = await triggerGetAppsMarketplace(urlParams.toString()).unwrap();
        } else {
            data = await triggerGetApplications(urlParams.toString()).unwrap();
        }

        app_data = data.items.at(0);
        if (app_data == undefined) {
            navigation("/not_found");
            return;
        }

        dispatch(setApplicationSelected(app_data));
    };

    useEffect(() => {
        dispatch(setPopupConfig());
        dispatch(setDialogConfig());
    }, [sectionSelected]);

    useEffect(() => {
        // Descomentar cuando se realice la separación de la información en local storage a session storage
        // if (
        //     applicationSelected.id === "0-0-0-0-0" ||
        //     Number(params.id) !== applicationSelected.id_application_company
        // ) {
        loadApplicationData();
        // }
    }, [params /*, applicationSelected*/]);

    return <Outlet />;
}
